import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconInsurance = function IconInsurance(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11a3 3 0 013-3c4.486 0 8.745-1.988 12.88-6.12a3 3 0 014.243 0C30.255 6.012 34.514 8 39 8a3 3 0 013 3v19c0 4.355-3.213 8.324-8.365 12.055C30.05 44.65 25.59 47 24 47s-6.05-2.35-9.635-4.945C9.213 38.324 6 34.355 6 30V11z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11a3 3 0 013-3c4.486 0 8.745-1.988 12.88-6.12a3 3 0 014.243 0C30.255 6.012 34.514 8 39 8a3 3 0 013 3v19c0 4.355-3.213 8.324-8.365 12.055C30.05 44.65 25.59 47 24 47s-6.05-2.35-9.635-4.945C9.213 38.324 6 34.355 6 30V11zm3 0v19c0 7 14 14 15 14s15-7 15-14V11c-5.333 0-10.333-2.333-15-7-4.667 4.667-9.667 7-15 7z"
  })));
};

export default IconInsurance;
